import {comMapping} from '../../../../util/Function/comMapping.js'
export function getdata(){
	var obj = {
		
			pagination:{
				pageNum: 1,
				pageSize: 50,
				total: 0,
				paginationkey:0
			},
			formlist: [{
				prop: "type",
				label: "类型",
				type: "select",
				width:"220px",
				selectval:[
					{
						label:"报表 ",
						value:"1"
					},
					{
						label:"完税凭证",
						value:"2"
					},
					{
						label:"涉税资料",
						value:"3"
					}
				]
			
			},{
				prop: "name",
				label: "名称",
				type: "input",
				width:"220px"
			
			},{
				prop: "description",
				label: "描述",
				type: "textarea",
				width:"380px"
			
			}], 
			searchlistzc: [
				{
					prop: "policyTitle",
					label: '标题',
					type: "input"
				},
				{
					prop: "policyType",
					label: '政策类型',
					type: "select",
					selectval: comMapping.$sszskzclx,
				},
				{
					prop: "isValid",
					label: '是否失效',
					type: "select",
					selectval: [
						{
							label: "是",
							value: "1"
						},
						{
							label: "否",
							value: "2"
						}
					],
				},
			],
			formdatazc: {
				policyTitle: "",
				isValid: "1",
				policyType: "1",
				fbDanw: "",
				policyNum: "",
				xianggxz: "",
				fabTime: "",
			},
			seezcformlist: [
				{
					prop: "policyTitle",
					label: "标题",
					type: "input",
					istosee: true
				},
				{
					prop: "policyNum",
					label: "发文字号",
					type: "input",
					istosee: true
				},
				{
					prop: "isValid",
					label: "是否失效",
					type: "radio",
					radioval: [
						{
							label: "是",
							value: "1"
						},
						{
							label: "否",
							value: "2"
						}
					],
					istosee: true
				},
				{
					prop: "xianggxz",
					label: "相关税种",
					type: "input",
					istosee: true
				},
				{
					prop: "policyType",
					label: "政策类型",
					type: "radio",
					istosee: true,
					radioval: comMapping.$sszskzclx,
				},
				{
					prop: "fabTime",
					label: "发文日期",
					type: "input",
					istosee: true
				},
			
				{
					prop: "implementTime",
					label: "施行日期",
					type: "input",
					istosee: true
				},
				{
					prop: "fbdanw",
					label: "发文机构",
					type: "input",
					istosee: true
				},
			],
			headDatazc: [
				{
					title: "标题",
					prop: "policyTitle",
					width: "200",
				},
				{
					title: "发文字号",
					prop: "policyNum",
					width: "200",
				},
				{
					title: "相关文档",
					prop: "policyFile",
					width: "200"
				},
				{
					title: "是否失效",
					prop: "isValid",
					width: "200",
					custom: true
				},
				{
					title: "政策类型",
					prop: "policyType",
					width: "150",
					custom: true
			
				},
				{
					title: "相关税种",
					prop: "xianggxz",
					width: "150"
				},
				{
					title: "发文日期",
					prop: "fabTime",
					width: "200"
				},
				{
					title: "施行日期",
					prop: "implementTime", width: "200"
				},
				{
					title: "发文机构",
					prop: "fbdanw",
					width: "200",
				},
			],
		otherDialog_8_tableData: [
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_1_0",
					cellVal: "--"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_1_1",
					cellVal: "xj"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_1_2",
					cellVal: "小计"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_1_3",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_1_4",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_1_5",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_2_0",
					cellVal: "1"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_2_1",
					cellVal: "tlcp"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_2_2",
					cellVal: "铁路车票（纸质报销凭证）"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_2_3",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_2_4",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_2_5",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_3_0",
					cellVal: "2"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_3_1",
					cellVal: "kpxcd"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_3_2",
					cellVal: "纸质航空运输电子客票行程单"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_3_3",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_3_4",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_3_5",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_4_0",
					cellVal: "3"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_4_1",
					cellVal: "dqtkp"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_4_2",
					cellVal: "注明旅客身份信息的公路、水路等其他客票"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_4_3",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_4_4",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_4_5",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_5_0",
					cellVal: "4"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_5_1",
					cellVal: "txffp"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_5_2",
					cellVal: "桥、闸通行费发票"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_5_3",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_5_4",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_5_5",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_6_0",
					cellVal: "5"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_6_1",
					cellVal: "ptfp"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_6_2",
					cellVal: "免税黄金普通发票"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_6_3",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_6_4",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_6_5",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_7_0",
					cellVal: "6"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_7_1",
					cellVal: "gbyt"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_7_2",
					cellVal: "不得抵扣且未抵扣进项固定资产、无形资产、不动产等改变用途"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_7_3",
					cellVal: "--"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_7_4",
					cellVal: "--"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_7_5",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_8b_x_0: {
					cellCode: "zzs_mxtk_2_8b_8_0",
					cellVal: "7"
				},
				zzs_mxtk_2_8b_x_1: {
					cellCode: "zzs_mxtk_2_8b_8_1",
					cellVal: "qt"
				},
				zzs_mxtk_2_8b_x_2: {
					cellCode: "zzs_mxtk_2_8b_8_2",
					cellVal: "其他"
				},
				zzs_mxtk_2_8b_x_3: {
					cellCode: "zzs_mxtk_2_8b_8_3",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_4: {
					cellCode: "zzs_mxtk_2_8b_8_4",
					cellVal: "0"
				},
				zzs_mxtk_2_8b_x_5: {
					cellCode: "zzs_mxtk_2_8b_8_5",
					cellVal: "0"
				},
			}
		],
		otherDialog_23_tableData: [
			{
				zzs_mxtk_2_23b_x_0: {
					cellCode: "zzs_mxtk_2_23b_1_0",
					cellVal: "--"
				},
				zzs_mxtk_2_23b_x_1: {
					cellCode: "zzs_mxtk_2_23b_1_1",
					cellVal: "xj"
				},
				zzs_mxtk_2_23b_x_2: {
					cellCode: "zzs_mxtk_2_23b_1_2",
					cellVal: "小计"
				},
				zzs_mxtk_2_23b_x_3: {
					cellCode: "zzs_mxtk_2_23b_1_3",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_23b_x_0: {
					cellCode: "zzs_mxtk_2_23b_2_0",
					cellVal: "1"
				},
				zzs_mxtk_2_23b_x_1: {
					cellCode: "zzs_mxtk_2_23b_2_1",
					cellVal: "dkfwjzjxgfy"
				},
				zzs_mxtk_2_23b_x_2: {
					cellCode: "zzs_mxtk_2_23b_2_2",
					cellVal: "贷款服务及直接相关费用"
				},
				zzs_mxtk_2_23b_x_3: {
					cellCode: "zzs_mxtk_2_23b_2_3",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_23b_x_0: {
					cellCode: "zzs_mxtk_2_23b_3_0",
					cellVal: "2"
				},
				zzs_mxtk_2_23b_x_1: {
					cellCode: "zzs_mxtk_2_23b_3_1",
					cellVal: "fysjyxm"
				},
				zzs_mxtk_2_23b_x_2: {
					cellCode: "zzs_mxtk_2_23b_3_2",
					cellVal: "非应税交易项目"
				},
				zzs_mxtk_2_23b_x_3: {
					cellCode: "zzs_mxtk_2_23b_3_3",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_23b_x_0: {
					cellCode: "zzs_mxtk_2_23b_4_0",
					cellVal: "3"
				},
				zzs_mxtk_2_23b_x_1: {
					cellCode: "zzs_mxtk_2_23b_4_1",
					cellVal: "ndqstz"
				},
				zzs_mxtk_2_23b_x_2: {
					cellCode: "zzs_mxtk_2_23b_4_2",
					cellVal: "用于简易计税项目、免税项目和非应税交易无法划分年度清算调整"
				},
				zzs_mxtk_2_23b_x_3: {
					cellCode: "zzs_mxtk_2_23b_4_3",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_23b_x_0: {
					cellCode: "zzs_mxtk_2_23b_5_0",
					cellVal: "4"
				},
				zzs_mxtk_2_23b_x_1: {
					cellCode: "zzs_mxtk_2_23b_5_1",
					cellVal: "cqzcjxsezce"
				},
				zzs_mxtk_2_23b_x_2: {
					cellCode: "zzs_mxtk_2_23b_5_2",
					cellVal: "长期资产进项税额转出额"
				},
				zzs_mxtk_2_23b_x_3: {
					cellCode: "zzs_mxtk_2_23b_5_3",
					cellVal: "0"
				},
			},
			{
				zzs_mxtk_2_23b_x_0: {
					cellCode: "zzs_mxtk_2_23b_6_0",
					cellVal: "5"
				},
				zzs_mxtk_2_23b_x_1: {
					cellCode: "zzs_mxtk_2_23b_6_1",
					cellVal: "qtjxsezc"
				},
				zzs_mxtk_2_23b_x_2: {
					cellCode: "zzs_mxtk_2_23b_6_2",
					cellVal: "其他进项税额转出"
				},
				zzs_mxtk_2_23b_x_3: {
					cellCode: "zzs_mxtk_2_23b_6_3",
					cellVal: "0"
				},
			},
		],
		
	}
	return obj
}
